<div [formGroup]="parentForm" id="parentForm">
  <!-- <div formGroupName="engageSettings"> -->
  <mat-card class="u-background-color-neutral-0">
    <mat-card-header>
      <mat-card-title>
        <img
          class="c-global-mat-icon"
          src="{{hostName}}/assets/images/icon-app-engage-coloured.svg"
        />
        {{ "Engage Settings" | moduleDisplayName | async }}
      </mat-card-title>
    </mat-card-header>
    <mat-card-content style="text-align: center; padding-left: 40px;">
      <div [formGroupName]="engageSettingsForm">
        <div fxLayout="row wrap">
          <h4>{{ "module-assignment.engage_settings.device_management" | translate }}</h4>
          <div fxFlex="100">
            <mat-card class="u-margin-bottom-15" style="padding: 5px;">
              <mat-card-header>
                <div fxFlex="20" class="u-text-left">
                  <mat-card-title style="padding-top:11px; padding-left: 20pt;">
                    {{'module-assignment.engage_settings.add_display' | translate}}
                  </mat-card-title>
                </div>
                <div fxFlex="80" class="u-text-right">
                  <button
                    style="background-color: transparent;
                      color: #000000;"
                    mat-flat-button
                    color="primary"
                    (click)="openScreenConfigurationOption()"
                    [disabled]="action === 'view'"
                  >
                    <mat-icon>add_box</mat-icon>
                  </button>
                </div>
              </mat-card-header>
              <mat-card-content
                *ngFor="let panels of parentForm.get(engageSettingsForm).get('displayList')['controls']; let i = index"
                formArrayName="displayList"
              >
                <div [formGroupName]="i" fxLayout="row wrap" fxLayoutGap="20px grid">
                  <div fxFlex="80" fxLayout="column">
                    <div
                      fxFlex="100"
                      fxFlex.gt-sm="100"
                      fxLayout="row wrap"
                      style="margin-left: 12px;"
                    >
                      <p *ngIf="isDeviceAdded">
                        {{ 'module-assignment.engage_settings.display_name' | translate }}<span
                          class="required-astrik"
                          >*</span
                        >
                      </p>
                      <mat-form-field style="padding-left: 55pt;">
                        <input matInput type="text" id="name" formControlName="displayName" />
                        <mat-error id="matFrmFieldDisplayNameRequired" class="error-message">
                          {{ "module-assignment.engage_settings.display_name_validation" | translate
                          }}
                        </mat-error>
                      </mat-form-field>
                      <mat-divider></mat-divider>
                    </div>
                    <div
                      fxFlex="100"
                      fxFlex.gt-sm="100"
                      fxLayout="row wrap"
                      style="margin-left: 12px;"
                    >
                      <p *ngIf="isDeviceAdded">
                        {{ "module-assignment.engage_settings.ip_address" | translate }}<span
                          class="required-astrik"
                          >*</span
                        >
                      </p>
                      <mat-form-field style="padding-left: 70pt;">
                        <input matNativeControl type="text" id="name" formControlName="ipAddress" />
                        <mat-error id="matFrmFieldDisplayNameRequired" class="error-message">
                          {{ "module-assignment.engage_settings.ip_address_validation" | translate
                          }}
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div fxFlex="20" class="u-text-right">
                    <button
                      style="background-color: transparent;
                    color: #000000;"
                      [disabled]="action=='view'"
                      mat-flat-button
                      color="primary"
                      (click)="deleteScreenDetailContainer(i);"
                    >
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>

        <!-- <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-top-10">
          <p>
            {{ "module-assignment.engage_settings.interact" | translate }}
          </p>

          <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-top-10">
            <mat-slide-toggle
              id="matSelectToggleInteract"
              formControlName="interact"
              (change)="toggleInteract()"
            >
            </mat-slide-toggle>
          </div>
        </div>
        <div id="stockMovementExport" [hidden]="isToggleInteract" class="u-margin-left-25">
          <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-top-10">
            <div fxFlex="100" fxFlex.gt-sm="40">
              <mat-form-field class="mat-block" id="matFrmFieldSupportedCurrencies">
                <mat-select
                  id="matSelectSupportedCurrencies"
                  formControlName="interactCtrl"
                  [placeholder]="'Interact'"
                  [multiple]="true"
                >
                  <mat-option *ngFor="let interact of interactCtrlOptions" [value]="interact">
                    {{interact.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div> -->
        <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-top-10">
          <p>
            {{ "module-assignment.engage_settings.inform" | translate }}
          </p>

          <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-top-10">
            <mat-slide-toggle
              id="matSelectToggleInform"
              formControlName="inform"
              (change)="toggleInform()"
            >
            </mat-slide-toggle>
          </div>
        </div>
        <div id="infrom" *ngIf="!isToggleInform" fxLayout="column" class="u-margin-left-25">
          <div>
            <div fxFlex="5" class="u-text-left">
              <p>
                {{'module-assignment.engage_settings.add_media' | translate}}
              </p>
            </div>
            <div fxFlex="3" class="u-text-right">
              <button
                style="background-color: transparent;
                  color: #000000;"
                mat-flat-button
                color="primary"
                (click)="addtableData()"
                [disabled]="action === 'view'"
              >
                <mat-icon>add_box</mat-icon>
              </button>
            </div>
          </div>
          <div>
            <p *ngIf="tableData.length === 0" style="color: #e30000d8;">
              {{'module-assignment.engage_settings.InformConfigError' | translate}}
            </p>
            <app-table
              [parentForm]="parentForm.get('engageSettingsForm').get('mediaConfig')"
              [tableData]="tableData"
              [selectedProducts]="selectedProducts"
              [tableCols]="tableCols"
              [nodeId]="nodeId"
              [orgCode]="orgCode"
              [tableRowDisabled]="tableRowDisabled"
              (selectedRowData)="paymentTenderSelectedRowData2($event)"
              (rowReorder)="tableRowOrder($event)"
              (deleteEmmiter)="handleDelete($event)"
              (durationChangeEmitter)="handleDurationChange($event)"
              (mediaPathEmitter)="handleMediaPathChange($event)"
              (imageUploadingEmitter)="handleimageUploadingEmitter($event)"
              [action]="action"
            >
            </app-table>
            <div class="u-text-left">
              <p>
                <b>{{'module-assignment.engage_settings.engage_image_config_note' | translate}}</b>
              </p>
              <p>
                <b
                  >{{'module-assignment.engage_settings.engage_image_config_note_line1' |
                  translate}}</b
                >
              </p>
              <p>
                <b
                  >{{'module-assignment.engage_settings.engage_image_config_note_line2' |
                  translate}}</b
                >
              </p>
              <p>
                <b
                  >{{'module-assignment.engage_settings.engage_image_config_note_line3' |
                  translate}}</b
                >
              </p>
            </div>
            <!-- <p>{{'module-assignment.engage_settings.engage_note' | translate}}</p> -->
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
  <!-- </div> -->
</div>
